import Vue from 'vue'
import Vuex from 'vuex'
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader'
import annisersary from './annisersary'

Vue.use(Vuex)
const loader = new GLTFLoader() //引入模型的loader实例
let timer = null
export default new Vuex.Store({
  state: {
    showGuide: false,
    weixinSign: '',
    models:[],
    metrails:[],
    inHomePage: false,
    metrailsLoaded:false,
    customizedCarModel:null,
    defaultMaterial:null,
  },
  mutations: {
    showGuideMutations(state, bool) {
      state.showGuide = bool
    },
    setWinxinSign(state, data) {
      state.weixinSign = data;
    },
    setModels (state,paload) {
      state.models = paload
    },
    setMetrails (state, paload) {
      state.metrails = paload
    },
    setinHomePage (state, paload) {
      state.inHomePage = paload
    },
    setMetrailsLoaded (state, paload) {
      state.metrailsLoaded = paload
    },
    setCustomizedCarModel (state , paload) {
      state.customizedCarModel = paload
    },
    setDefaultMaterial (state, paload) {
      state.defaultMaterial = paload
    }
  },
  actions: {
    loadMetrail (context) {
      let metrailList = []
      let carBodyMetrails = [
        {
          imgUrl:'',
          gltfUrl:'https://36kr-zero.oss-cn-beijing.aliyuncs.com/2022/06/32/NFTCarModels/materials/lowPixelMaterial.gltf',
          // gltfUrl: `https://36kr-zero.oss-cn-beijing.aliyuncs.com/2022/06/32/NFTCarModels/materials/allMaterials.gltf`
          // gltfUrl:'https://36kr-zero.oss-cn-beijing.aliyuncs.com/2022/06/32/NFTCarModels/materials/allMaterial-processed.gltf'
        }
      ]
      console.log(timer,'1234');
      if(!timer) {
        timer = setTimeout(() => {
          for ( let m = 0 ; m < carBodyMetrails.length ; m ++) {
            const element = carBodyMetrails[m]
            console.log('开始加载材质包');
            loader.load(element.gltfUrl, (metrail) => {
              // metrail.scene.scale.set(0.001,0.001,0.001)
              console.log(metrail);
              let metrailGltf = {
                imgUrl:element.imgUrl,
                metrail:metrail
              }
              metrailList.push(metrailGltf)
              context.commit('setMetrails',metrailList)
              context.commit ('setMetrailsLoaded',true)
              
              console.log('材质加载完成');
              clearTimeout(timer)
              timer = null
            },
            () => {},
            () => {
              console.log("加载失败重新加载");
             this.loadMetrail(context)
            }
            )
          }
        },100)
      }
    }
  },
  modules: {
    annisersary,
  }
})
